























































import {Vue, Component} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import moment from "moment";
import {PutniNalog} from "@/services/BackendProxies";
import {formatDate} from "@/utils/formatters";

@Component({})
export default class PregledPutnihNaloga extends mixins(ComponentBaseMixin) {
    putniNalozi = [];
    columns = [];
    tableOptions = {
      headerStyle: () => {return {css: {'font-size' : '12px'}}},
        search: true,
        onClickRow: row => this.onClickRow(row)
    };
    odDatuma = moment().startOf('month').toDate();
    doDatuma = moment().endOf('month').toDate();
    osobaID: number = null;
    voziloID: number = null;

    filterVisible = false;
    isBusy = false;
    brojNaloga = '';

    async created() {
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum'), width: 80, formatter: formatDate},
            {field: 'broj', title: this.$i18n.t('broj'), width: 90},
            {field: 'relacija', title: this.$i18n.t('relacija'), width: 110},
            {field: 'vozac', title: this.$i18n.t('vozac'), width: 120},
            {field: 'vozilo', title: this.$i18n.t('vozilo'), width: 120},
            {field: 'polaznaKilometraza', title: this.$i18n.t('polaznaKM'), width: 65, align: 'right'},
            {field: 'krajnjaKilometraza', title: this.$i18n.t('krajnjaKM'), width: 60, align: 'right'},
            {field: 'predjenoKilometara', title: this.$i18n.t('predjenoKM'), width: 65, align: 'right'},
            {field: 'ukupnoVreme', title: this.$i18n.t('ukupnoVreme'), formatter: this.vremeFormatter, width: 70, align: 'right'},
            {field: 'status', title: this.$i18n.t('status'), width: 60, formatter: this.statusFormatter},
        ];

        this.pretraziPutneNaloge();
    }

    async pretraziPutneNaloge() {
        try {
            this.isBusy = true;
            this.putniNalozi = await this.loadData(() => dataProxy.vratiPutneNaloge(this.odDatuma, this.doDatuma, this.osobaID, this.brojNaloga, this.voziloID))();
        } finally {
            this.isBusy = false;
        }
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    get postavljenFilter() {
        return !!this.brojNaloga || !!this.osobaID || !!this.voziloID;
    }

    onClickRow(row: PutniNalog) {
        this.$router.push('unos-putnog-naloga/' + row.id);
    }

    statusFormatter(status) {
        switch (status) {
            case 1: return '<i class="fa fa-folder-open" />'
            case 2: return '<i class="fa fa-check" />'
        }
    }

    vremeFormatter(value) {
        const hours = Math.round(value / 60);
        const minuntes = value % 60;
        return `${hours}:${minuntes < 10 ? '0' + minuntes : minuntes}`;
    }
}
